import firebase from 'firebase'

var config = {
    apiKey: "AIzaSyCzAbawVX-Zzb9A6Zz51iiwX9jZZ2LuRjg",
    authDomain: "my-pharma-9670e.firebaseapp.com",
    databaseURL: "https://my-pharma-9670e.firebaseio.com",
    projectId: "my-pharma-9670e",
    storageBucket: "my-pharma-9670e.appspot.com",
    messagingSenderId: "1043210853292",
    appId: "1:1043210853292:web:ec58d812c98f439bfc3809",
    measurementId: "G-JTLZHKKGJW"
}

firebase.initializeApp(config)
let fcm_server_key = "AAAA8uQ2W6w:APA91bGshSBaYZJm_xvaJapuKN3h3aKw-zRLrXWfmq4pArFLN88kprzo2i8i5V7VdylqThn8ibbx-urLZ53UoCo55jBKAOOPDpUYN6nVNEiKue8JC6OUUh6WjrSn9E0cCU0tFhKBcEIL";

/*export const initializeFirebase = () => {
    firebase.initializeApp(config)
};*/

export default{
     messaging : firebase.messaging()
}

export const askForPermissioToReceiveNotifications = async (user) => {
    try {
        const messaging = firebase.messaging();
        await messaging.requestPermission();
        await messaging.getToken().then((token) => {
            console.log('token do usuário:', token);
            console.log('user:', user);
            subscribeTokenToTopic(token, "commandes");
        }).catch((err) => console.log('--- token error:', err))
         /*const registration = await navigator.serviceWorker
                   .register('../../firebase-messaging-sw.js', {
                       updateViaCache: 'none'
                   });
               await messaging.useServiceWorker(registration)*/

    } catch (error) {
        console.error(error);
    }
}

export const subscribeTokenToTopic = async (token, topic) => {
    fetch('https://iid.googleapis.com/iid/v1/' + token + '/rel/topics/' + topic, {
        method: 'POST',
        headers: new Headers({
            'Authorization': 'key=' + fcm_server_key
        })
    }).then(response => {
        if (response.status < 200 || response.status >= 400) {
            throw 'Error subscribing to topic: ' + response.status + ' - ' + response.text();
        }
        console.log('Subscribed to "' + topic + '"');
    }).catch(error => {
        console.error(error);
        console.log('Subscribed error "' + topic + '"');
    })
};
firebase.messaging().onMessage(function (payload) {
    console.log("payload cus", payload)

    // Customize notification here
    var notificationTitle = 'Notification title';
    var notificationOptions = {
        body: payload.data.alert,
        icon: ''
    };


    var notification = new Notification(notificationTitle, notificationOptions);

    notification.onclick = function (event) {
        notification.close();
        event.preventDefault();
        //handle click event onClick on Web Push Notification
    };
});

